import React from "react";
import { Link } from "react-router-dom";
import { PurchaseOrder } from "../../api/order/generated/src";
import { format } from "date-fns";

interface IOrderListItemProps {
    item: PurchaseOrder;
}

const OrderListItem = (props:IOrderListItemProps) => {
    const { item } = props;

    return (
        <Link to={`/purchaseorder/${item.id}`}>
            <div className="gap-4 grid w-full rounded-lg bg-white shadow-lg p-4 mb-4">
                <div className="flex flex-col gap-4">
                    <div>
                        {item.annotation}
                    </div>

                    <div className="flex flex-row gap-4">
                        
                        <div className="grow">
                            {item.externalId}
                        </div>
                        <div>
                            {item.tsCreated != null && format(item.tsCreated, "dd.MM.yyyy")}
                        </div>

                    </div>
                    
                    <div>{item.vendor?.name}</div>
                </div>
                
                
            </div>
        </Link>
    )
};

export default OrderListItem;
